import { AuthMessage } from '@/constants/auth/auth'

export enum Message {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  DEFAULT = 'default'
}

export const MessageTitle = {
  [AuthMessage.USER_DOES_NOT_EXIST]: 'This user does not exists',
  [AuthMessage.INVALID_CREDENTIALS]: 'Your email or password is incorrect',
  [AuthMessage.EMAIL_ALREADY_EXISTS]: 'This Email is already taken',
  [AuthMessage.PASSWORD_TOO_SHORT]: 'Your password is too short.',
  [AuthMessage.UNABLE_TO_FETCH]: 'An unknown error occured',
  [AuthMessage.INTERNAL_SERVER_ERROR]: 'An unknown error occured',
  [AuthMessage.PASSWORD_RESET_LINK_SENT]: 'Reset Link Sent',
  [AuthMessage.PASSWORD_RESET_SUCCESSFUL]: 'Password Reset Successful',
  [AuthMessage.TOO_MANY_ATTEMPTS]: 'Too many attempts',
  [AuthMessage.INVALID_TOKEN]: 'Invalid Link',
  [AuthMessage.TOKEN_EXPIRED]: 'Token already expired',
  [AuthMessage.PASSWORD_RESET_TOKEN_VERIFICATION_FAILED]: 'Token verification failed',
  [AuthMessage.INVITATION_ACCEPTED]: 'Invitation Successfully Accepted',
  [AuthMessage.INVITATION_ERROR]: 'Error on accepting an Invite',
  [AuthMessage.INVALID_TIMEZONE]: 'Invalid Timezone'
}
